import React, { useState, useEffect } from 'react';
import { IoLogoTiktok, IoLogoInstagram, IoLogoWhatsapp, IoShareSocial, IoLocationOutline } from "react-icons/io5";
import { RiPhoneFill } from 'react-icons/ri';
import { FaFacebookF, FaWaze, FaCar } from "react-icons/fa";
import SocialLink from '../elements/SocialLink';

const Social = ({ phoneNumber, phoneText, whatsappNumber, facebookUrl, wazeUrl, wazeText, locationUrl, instagramUsername, tiktokUsername, shareUrl, type }) => {
    const socialLinksData = [
        { text: phoneText, icon: RiPhoneFill, action: () => handlePhoneClick(phoneNumber), data: phoneNumber },
        { text: 'ווטסאפ', icon: IoLogoWhatsapp, action: () => handleWhatsappClick(whatsappNumber), data: whatsappNumber },
        { text: 'פייסבוק', icon: FaFacebookF, action: () => handleFacebookClick(facebookUrl), data: facebookUrl },
        { text: 'דף פייסבוק', icon: FaFacebookF, action: () => handleFacebookClick('https://www.facebook.com/Oksifre.cosmetics.care'), data: 'https://www.facebook.com/Oksifre.cosmetics.care' },
        { text: wazeText, icon: FaCar, action: () => handleWazeClick(wazeUrl), data: wazeUrl },
        { text: 'מיקום', icon: IoLocationOutline, action: () => handleLocationClick(locationUrl), data: locationUrl },
        { text: 'אינסטגרם', icon: IoLogoInstagram, action: () => handleInstagramClick(instagramUsername), data: instagramUsername },
        { text: 'טיקטוק', icon: IoLogoTiktok, action: () => handleTiktokClick(tiktokUsername), data: tiktokUsername },
        { text: 'שיתוף', icon: IoShareSocial, action: () => handleShareUrl(shareUrl), data: shareUrl },
    ].filter(linkData => linkData.data !== null && linkData.data !== undefined && linkData.data !== '');

    const renderSocialLinks = socialLinksData.map((linkData, index) => (
        <SocialLink
            key={index}
            text={linkData.text}
            icon={linkData.icon}
            onClickAction={linkData.action}
            type={type}
        />
    ));

    const [isLargeScreen, setIsLargeScreen] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
            setIsLargeScreen(window.innerWidth > 768);
        };

        checkScreenSize();

        window.addEventListener('resize', checkScreenSize);

        return () => {
            window.removeEventListener('resize', checkScreenSize);
        };
    }, []);

    const handlePhoneClick = (phoneNumber) => {
        const phoneLink = `tel:${phoneNumber}`;
        window.location.href = phoneLink; // This will initiate the call directly without opening a new window
    };
    

    const handleWhatsappClick = (whatsappNumber) => {
        const phoneNumber = whatsappNumber.replace(/\D/g, '');
        const whatsappLink = `https://wa.me/${phoneNumber}`;
        window.open(whatsappLink, '_blank');
    };

    const handleFacebookClick = (facebookUrl) => {
        window.open(facebookUrl, '_blank');
    };

    const handleInstagramClick = (instagramUsername) => {
        const instagramLink = `https://www.instagram.com/${instagramUsername}`;
        window.open(instagramLink, '_blank');
    };

    const handleTiktokClick = (tiktokUsername) => {
        const tiktokLink = `https://www.tiktok.com/@${tiktokUsername}`;
        window.open(tiktokLink, '_blank');
    };

    const handleWazeClick = (wazeUrl) => {
        window.open(wazeUrl, '_blank');
    };

    const handleLocationClick = (locationUrl) => {
        window.open(locationUrl, '_blank');
    };

    const handleShareUrl = (shareUrl) => {
        const isAbsoluteUrl = shareUrl.startsWith('http://') || shareUrl.startsWith('https://');
        const absoluteUrl = isAbsoluteUrl ? shareUrl : new URL(shareUrl, window.location.href).href;

        if (navigator.share) {
            navigator.share({
                title: 'Digicard',
                text: 'כרטיס ביקור דיגיטלי',
                url: absoluteUrl,
            })
            .then(() => console.log('URL shared successfully'))
            .catch((error) => console.error('Error sharing URL:', error));
        } else {
            window.open(absoluteUrl, '_blank');
        }
    };

    const renderSocial = () => {
        const data = socialLinksData;

        if (data.length === 1) {
            return (
                <div className='w-full flex mx-auto justify-around'>{renderSocialLinks}</div>
            );
        } else if (data.length === 2) {
            return (
                <div className='w-[80%] flex mx-auto justify-around max-w-[500px]'>{renderSocialLinks}</div>
            );
        } else if (data.length === 3) {
            return (
                <div className='w-full flex mx-auto justify-around max-w-[500px]'>{renderSocialLinks}</div>
            );
        } else if (data.length === 4) {
            return (
                <>
                    <div className='hidden sm:block'>
                        <div className='w-full flex mx-auto justify-around'>{renderSocialLinks}</div>
                    </div>
                    <div className='sm:hidden'>
                        <div className='w-[80%] flex mx-auto justify-around '>{renderSocialLinks.slice(0, 2)}</div>
                        <div className='w-[80%] flex mx-auto justify-around '>{renderSocialLinks.slice(2)}</div>
                    </div>
                </>
            );
        } else if (data.length === 5) {
            return (
                <>
                    <div className='hidden sm:block'>
                        <div className='w-full flex mx-auto justify-around'>{renderSocialLinks}</div>
                    </div>
                    <div className='sm:hidden'>
                        <div className='w-full flex mx-auto justify-around'>{renderSocialLinks.slice(0, 3)}</div>
                        <div className='w-[80%] flex mx-auto justify-around'>{renderSocialLinks.slice(3)}</div>
                    </div>
                </>
            );
        } else if (data.length === 6) {
            return (
                <>
                    <div className='hidden sm:block'>
                        <div className='w-full flex mx-auto justify-around'>{renderSocialLinks}</div>
                    </div>
                    <div className='sm:hidden'>
                        <div className='w-full flex mx-auto justify-around'>{renderSocialLinks.slice(0, 3)}</div>
                        <div className='w-full flex mx-auto justify-around'>{renderSocialLinks.slice(3)}</div>
                    </div>
                </>
            );
        } else if (data.length === 7) {
            return (
                <>
                    <div className='hidden sm:block '>
                        <div className='w-full flex mx-auto justify-around'>{renderSocialLinks.slice(0, 4)}</div>
                        <div className='w-[80%] flex mx-auto justify-around'>{renderSocialLinks.slice(4, 7)}</div>
                    </div>
                    <div className='sm:hidden'>
                        <div className='w-full flex mx-auto justify-around'>{renderSocialLinks.slice(0, 3)}</div>
                        <div className='w-full flex mx-auto justify-around'>{renderSocialLinks.slice(3, 6)}</div>
                        <div className='w-full flex mx-auto justify-around'>{renderSocialLinks.slice(6)}</div>
                    </div>
                </>
            );
        } else if (data.length === 8) {
            return (
                <>
                    <div className='hidden sm:block '>
                        <div className='w-full flex mx-auto justify-around'>{renderSocialLinks.slice(0, 4)}</div>
                        <div className='w-full flex mx-auto justify-around'>{renderSocialLinks.slice(4, 8)}</div>
                    </div>
                    <div className='sm:hidden'>
                        <div className='w-full flex mx-auto justify-around'>{renderSocialLinks.slice(0, 3)}</div>
                        <div className='w-full flex mx-auto justify-around'>{renderSocialLinks.slice(3, 6)}</div>
                        <div className='w-[80%] flex mx-auto justify-around'>{renderSocialLinks.slice(6)}</div>
                    </div>
                </>
            );
        } else if (data.length === 9) {
            return (
                <>
                    <div className='hidden lg:block'>
                        <div className='w-full flex mx-auto justify-around'>{renderSocialLinks.slice(0, 5)}</div>
                        <div className='w-[80%] flex mx-auto justify-around '>{renderSocialLinks.slice(5)}</div>
                    </div>
                    <div className='hidden sm:block lg:hidden'>
                        <div className='w-full flex mx-auto justify-around'>{renderSocialLinks.slice(0, 5)}</div>
                        <div className='w-[80%]  flex mx-auto justify-around'>{renderSocialLinks.slice(5)}</div>
                    </div>
                    <div className='sm:hidden'>
                        <div className='w-full flex mx-auto justify-around'>{renderSocialLinks.slice(0, 3)}</div>
                        <div className='w-full flex mx-auto justify-around'>{renderSocialLinks.slice(3, 6)}</div>
                        <div className='w-full flex mx-auto justify-around'>{renderSocialLinks.slice(6)}</div>
                    </div>
                </>
            );
        } else {
            return (
                <>
                    <div className='w-full flex mx-auto justify-around'>{renderSocialLinks.slice(0, 3)}</div>
                    <div className='w-full flex mx-auto justify-around'>{renderSocialLinks.slice(3, 6)}</div>
                    <div className='w-full flex mx-auto justify-around'>{renderSocialLinks.slice(6, 9)}</div>
                    <div className='w-full flex mx-auto justify-around'>{renderSocialLinks.slice(9)}</div>
                </>
            );
        }
    };

    return (
        <div className='mt-8'>
            {renderSocial()}
        </div>
    );
};

export default Social;
